import { computed, type Ref } from 'vue';
import Fuse from 'fuse.js';
import type { CrmMedewerkersGetMedewerkersVoorContactpaginaDto } from '@services/crm-public/orval-api/model/crmMedewerkersGetMedewerkersVoorContactpaginaDto';

type ContactpaginaData = CrmMedewerkersGetMedewerkersVoorContactpaginaDto;
type Medewerker = ContactpaginaData['afdelingen'][0]['medewerkers'][0];
type Afdeling = ContactpaginaData['afdelingen'][0];

interface MedewerkerMetAfdeling {
  medewerker: Medewerker;
  afdeling: Afdeling;
}

export function useContactpaginaSearch(
  data: Ref<ContactpaginaData | undefined>,
  searchQuery: Ref<string>,
) {
  const gefilterdeData = computed(() => data.value);

  const medewerkerMetAfdelingLijst = computed<MedewerkerMetAfdeling[]>(() => {
    if (!data.value) return [];

    return data.value.afdelingen.flatMap((afdeling) =>
      afdeling.medewerkers.map((medewerker) => ({
        medewerker,
        afdeling,
      })),
    );
  });

  const gefilterdeMedewerkerIds = computed(() => {
    const term = searchQuery.value.trim();
    if (!term || term.length < 2) return null;

    const fuse = new Fuse(medewerkerMetAfdelingLijst.value, {
      keys: [
        'medewerker.volledigeNaam',
        'medewerker.email',
        'medewerker.telefoonnummer',
        'medewerker.functie',
        'afdeling.omschrijving',
      ],
      threshold: 0.3,
    });

    return new Set(fuse.search(term).map((result) => result.item.medewerker.gebruikerId));
  });

  const isZichtbaar = (medewerker: Medewerker): boolean => {
    if (!gefilterdeMedewerkerIds.value) return true;
    return gefilterdeMedewerkerIds.value.has(medewerker.gebruikerId);
  };

  return {
    gefilterdeData,
    isZichtbaar,
  };
}
